import { createSelector } from '@reduxjs/toolkit';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { selectExperiments } from 'shared/selectors/experiments/selectExperiments';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { isExperimentActive } from 'shared/utils/experiments';

export const useExperiment = (experimentName: string, groupName = 'B') => {
  const { config } = useApplicationContext();

  const enabledExperimentNames = config.get<string[]>('enabledExperimentNames') || [];

  const isExperimentEnabledSelector = useCallback(
    createSelector([selectExperiments], experiments => isExperimentActive(experiments, experimentName, groupName)),
    [experimentName, groupName],
  );

  const isExperimentEnabled = useSelector(isExperimentEnabledSelector);

  return isExperimentEnabled || enabledExperimentNames.includes(experimentName);
};
